import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatIndentIncreaseComponent } from "./med-icon-format-indent-increase.component";

@NgModule({
  declarations: [
    MedIconFormatIndentIncreaseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatIndentIncreaseComponent,
  ],
})
export class MedIconFormatIndentIncreaseModule { }
